// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"f4e2f76b","239":"bd937028","453":"f45e0143","455":"75c701ef","977":"1ae4e3e4"}[chunkId] + ".chunk.js";
};